import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.getHeight
import com.github.chosamuel.kishibe.application.getWidth
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.graphics.Mesh
import com.github.chosamuel.kishibe.math.Vector2

fun Application.meshFromSquareGrid(grid: List<List<Vector2>>): Mesh {
    val m = Mesh(gl,this)
    grid.forEach { row->
        row.forEach{
            m.addVertex(it)
            m.addColor(Color(1.0,0.0,0.0))
        }
    }
    return m
}

fun Application.springParticleGridToMesh(grid: List<List<SpringParticle>>): Mesh {
    val m = Mesh(gl,this)
    grid.forEachIndexed { y,row->
        row.forEachIndexed { x, it->
           m.addVertex(it.pos)
           m.addColor(Color(
               x.toDouble() / dim.toDouble(),
               y.toDouble() / dim.toDouble(),
               0.0
           ))
        }
    }
    return m
    return TODO()
}

fun Application.springParticleGridToLineMesh(grid:List<List<SpringParticle>>): Mesh {
    val m = springParticleGridToMesh(grid)
    for(y in 0 until grid.size) {
        for (x in 0 until grid[y].size){
            if( x < grid.size -1) {
                m.addIndex((y * grid.size + x).toShort())
                m.addIndex((y * grid.size + (x + 1)).toShort())
            }
            if(y < grid.size - 1){
                m.addIndex((y * grid.size + x).toShort())
                m.addIndex(((y+1) * grid.size + x).toShort())
            }
        }
    }
    return m
}

fun Application.lineMeshFromSquareGrid(grid:List<List<Vector2>>): Mesh {
    val m = meshFromSquareGrid(grid)
    for(y in 0 until grid.size) {
        for (x in 0 until grid[y].size){
            if( x < grid.size -1) {
                m.addIndex((y * grid.size + x).toShort())
                m.addIndex((y * grid.size + (x + 1)).toShort())
            }
            if(y < grid.size - 1){
                m.addIndex((y * grid.size + x).toShort())
                m.addIndex(((y+1) * grid.size + x).toShort())
            }
        }
    }
    return m
}

fun Application.triangleMeshFromSquareGrid(grid: List<List<Vector2>>): Mesh {
    val m = meshFromSquareGrid(grid)
    for(y in 0 until grid.size - 1) {
        for (x in 0 until grid[y].size - 1){
            m.addIndex((y * grid.size + x).toShort())
            m.addIndex((y * grid.size + (x+1)).toShort())
            m.addIndex(((y+1) * grid.size + x).toShort())
            m.addIndex((y * grid.size + (x+1)).toShort())
            m.addIndex(((y+1) * grid.size + (x+1)).toShort())
            m.addIndex(((y+1) * grid.size + x).toShort())
        }
    }
    return m
}

fun Application.springParticleToTriangleMesh(grid: List<List<SpringParticle>>): Mesh {
    val m = springParticleGridToMesh(grid)
    for(y in 0 until grid.size - 1) {
        for (x in 0 until grid[y].size - 1){
            m.addIndex((y * grid.size + x).toShort())
            m.addIndex((y * grid.size + (x+1)).toShort())
            m.addIndex(((y+1) * grid.size + x).toShort())
            m.addIndex((y * grid.size + (x+1)).toShort())
            m.addIndex(((y+1) * grid.size + (x+1)).toShort())
            m.addIndex(((y+1) * grid.size + x).toShort())
        }
    }
    return m
}
